import { render, staticRenderFns } from "./XalqaroNewsView.vue?vue&type=template&id=64f3d3da&"
import script from "./XalqaroNewsView.vue?vue&type=script&lang=js&"
export * from "./XalqaroNewsView.vue?vue&type=script&lang=js&"
import style0 from "./XalqaroNewsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports